<!--  -->
<template>
  <div class="firm-body">
    <!-- 面包屑  -->
    <p class="title-Individual-center">
      <span>招聘管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="firm-clickable" @click="goZy">职位管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ routeName }}</span>
    </p>

    <div class="box">
      <!-- 与发布页保持一致：右上角返回 -->
      <div class="Back-btn" @click="goZy">
        <div class="Back-style">
          <div></div>
          <p>返回</p>
        </div>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-suffix="："
      >
        <el-row :gutter="20" justify="space-between">
          <el-col :span="12">
            <el-form-item>
              <div class="box-title">
                <span>基本信息</span>
                <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <div class="box-title">
                <span>职位要求</span>
                <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业名称">
              <div style="height: 30px">{{ ruleForm.companyName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作经验" prop="workExperience">
              <el-select
                v-model="ruleForm.workExperience"
                placeholder="请选择工作经验"
              >
                <el-option
                  :label="item.name"
                  :value="Number(item.id)"
                  v-for="(item, index) in workExpEnumList"
                  :key="index"
                  >{{ item.name }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 职位类型 -->
            <el-form-item label="招聘类型" prop="jobType">
              <div class="flex-box" style="justify-content: start">
                <div
                  :class="
                    ruleForm.jobType == item.id
                      ? 'type-box-active type-box'
                      : 'type-box'
                  "
                  v-for="(item, index) in jobTypeList"
                  :key="index"
                  @click="ruleForm.jobType = item.id"
                >
                  {{ item.name }}
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学历要求" prop="education" style="width: 100%">
              <div class="flex-box2" style="flex-wrap: wrap">
                <div
                  :class="
                    ruleForm.education == item.id
                      ? 'type-box-active type-box'
                      : 'type-box'
                  "
                  v-for="(item, index) in xlList"
                  :key="index"
                  @click="ruleForm.education = item.id"
                >
                  {{ item.name }}
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="margin-top: -50px">
            <el-form-item label="招聘职位" prop="positionName">
              <el-input
                v-model="ruleForm.positionName"
                placeholder="请输入职位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="薪资范围"
              prop="salaryMonths"
              style="width: 100%"
            >
              <el-select
                v-model="ruleForm.salaryMin"
                placeholder="请选择"
                style="width: 145px"
                @change="salaryMinChange"
              >
                <el-option
                  :label="item.label"
                  :value="Number(item.value)"
                  v-for="(item, index) in salaryList"
                  :key="index"
                ></el-option>
              </el-select>
              <span style="margin: 0 21px" v-show="ruleForm.salaryMin !== 0">至</span>
              <el-select
                v-if="ruleForm.salaryMin !== 0"
                v-model="ruleForm.salaryMax"
                placeholder="请选择"
                style="width: 145px"
                @change="salaryMaxChange"
              >
                <el-option
                  :label="item.label"
                  :value="Number(item.value)"
                  v-for="(item, index) in salaryList2"
                  :key="index"
                ></el-option>
              </el-select>
              <el-select
                v-if="ruleForm.salaryMin !== 0"
                v-model="ruleForm.salaryMonths"
                placeholder="请选择"
                style="width: 94px; margin-left: 20px"
              >
                <el-option
                  :label="item.name"
                  :value="item.value"
                  v-for="(item, index) in salaryMonthsList"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="margin-top: -40px">
            <el-form-item label="职位描述" prop="positionDescribe">
              <el-input
                type="textarea"
                resize="none"
                placeholder="请输入至少30个字的描述，请勿填写QQ、微信、电话等联系方式及特殊符号、性别歧视、违反劳动法相关内容、否则有可能会导致您的账号被封禁"
                v-model="ruleForm.positionDescribe"
                maxlength="1500"
                :autosize="{ minRows: 6, maxRows: 6 }"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职业类别" prop="dictPositionCode">
              <el-input class="firm-clickable"
                placeholder="请选择职业类别"
                @click.native="PositionAndProfession = true"
                v-model="ruleForm.codeName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作地点" prop="companyInfoAddressId">
              <el-select
                v-model="ruleForm.companyInfoAddressId"
                placeholder="请选择工作地点"
              >
                <el-option
                  :label="item.name"
                  :value="Number(item.id)"
                  v-for="(item, index) in companyAddressList"
                  :key="index"
                  >{{ item.name }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="需要技能" prop="skillIds">
              <!-- 与发布页保持一致：弹层不撑高整体高度 -->
              <div class="skill-wrapper">
                <div
                  class="flex-box"
                  style="justify-content: start; flex-wrap: wrap"
                >
                  <div
                    :class="
                      item.checked ? 'type-box-active type-box' : 'type-box'
                    "
                    v-for="(item, index) in customizePositionSkillList"
                    :key="index"
                    @click="skillChange(item, index)"
                  >
                    {{ item.skillName }}
                    <img
                      class="guanbi firm-clickable"
                      @click="closeJn(item)"
                      src="@/assets/imgs/guanbi@3x.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="type-box firm-clickable"
                    v-if="customizePositionSkillList.length < 8"
                    @click="isShow = true"
                  >
                    <img
                      src="@/assets/imgs/tianjia@3x.svg"
                      alt=""
                      style="margin-right: 5px; width: 18px"
                    />
                    添加技能
                  </div>
                </div>
                <div class="flex-box2 skill-add-pop" v-if="isShow">
                  <el-input
                    v-model="addJnVal"
                    placeholder="请输入"
                    style="width: 200px; margin-right: 15px"
                  ></el-input>
                  <el-button
                    type="primary"
                    @click="addJn"
                    :disabled="!addJnVal || !addJnVal.trim()"
                    style="width: 70px"
                    >确认</el-button
                  >
                  <el-button
                    type="primary"
                    @click="isShow = false"
                    style="width: 70px"
                    >取消</el-button
                  >
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="margin: 100px auto">
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              style="
                width: 120px;
                font-size: 16px;
                margin-left: 200px;
                height: 40px;
              "
              >保存</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <div>
        <div style="text-align: center; font-size: 16px"
          >发布即表示已阅读并遵守<span
            style="color: #409eff ; cursor: pointer"
            @click="handelAgreement"
            >《招聘信息发布规范》</span
          >
        </div>
      </div>
      <Position
        :PositionAndProfession="PositionAndProfession"
        :positionCode="ruleForm.dictPositionCode"
        @handleClose="handleClose"
        @handleUnderstand="handleUnderstand"
      ></Position>
    </div>
  </div>
</template>

<script>
import Position from "../../../../components/Position.vue";
import { workExpEnumList, jobTypeList, xlList } from "@/assets/js/common.js";
import * as API from "@/assets/api/firm/firmRecruit.js";
export default {
  components: { Position },
  data() {
    var skillIds = (rule, value, callback) => {
      if (this.customizePositionSkillList.some((item) => item.checked)) {
        callback();
      } else {
        callback(new Error("请选择至少一条拥有技能！"));
      }
    };
    return {
      visible: false,
      routeName: "",
      // 工作经验列表
      workExpEnumList,
      //   学历要求
      xlList,
      // 招聘类型
      jobTypeList,
      // 薪资范围
      salaryList: [
        {
          value: "0",
          label: "面议",
        },
        {
          value: "1000",
          label: "1k",
        },
        {
          value: "2000",
          label: "2k",
        },
        {
          value: "3000",
          label: "3k",
        },
        {
          value: "4000",
          label: "4k",
        },
        {
          value: "5000",
          label: "5k",
        },
        {
          value: "6000",
          label: "6k",
        },
        {
          value: "7000",
          label: "7k",
        },
        {
          value: "8000",
          label: "8k",
        },
        {
          value: "9000",
          label: "9k",
        },
        {
          value: "10000",
          label: "10k",
        },
        {
          value: "11000",
          label: "11k",
        },
        {
          value: "12000",
          label: "12k",
        },
        {
          value: "13000",
          label: "13k",
        },
        {
          value: "14000",
          label: "14k",
        },
        {
          value: "15000",
          label: "15k",
        },
        {
          value: "16000",
          label: "16k",
        },
        {
          value: "17000",
          label: "17k",
        },
        {
          value: "18000",
          label: "18k",
        },
        {
          value: "19000",
          label: "19k",
        },
        {
          value: "20000",
          label: "20k",
        },
        {
          value: "21000",
          label: "21k",
        },
        {
          value: "22000",
          label: "22k",
        },
        {
          value: "23000",
          label: "23k",
        },
        {
          value: "24000",
          label: "24k",
        },
        {
          value: "25000",
          label: "25k",
        },
        {
          value: "26000",
          label: "26k",
        },
        {
          value: "27000",
          label: "27k",
        },
        {
          value: "28000",
          label: "28k",
        },
        {
          value: "29000",
          label: "29k",
        },
        {
          value: "30000",
          label: "30k",
        },
        {
          value: "35000",
          label: "35k",
        },
        {
          value: "40000",
          label: "40k",
        },
        {
          value: "45000",
          label: "45k",
        },
        {
          value: "50000",
          label: "50k",
        },
        {
          value: "55000",
          label: "55k",
        },
        {
          value: "60000",
          label: "60k",
        },
      ],
      salaryList2: [
        {
          value: "0",
          label: "面议",
        },
        {
          value: "1000",
          label: "1k",
        },
        {
          value: "2000",
          label: "2k",
        },
        {
          value: "3000",
          label: "3k",
        },
        {
          value: "4000",
          label: "4k",
        },
        {
          value: "5000",
          label: "5k",
        },
        {
          value: "6000",
          label: "6k",
        },
        {
          value: "7000",
          label: "7k",
        },
        {
          value: "8000",
          label: "8k",
        },
        {
          value: "9000",
          label: "9k",
        },
        {
          value: "10000",
          label: "10k",
        },
        {
          value: "11000",
          label: "11k",
        },
        {
          value: "12000",
          label: "12k",
        },
        {
          value: "13000",
          label: "13k",
        },
        {
          value: "14000",
          label: "14k",
        },
        {
          value: "15000",
          label: "15k",
        },
        {
          value: "16000",
          label: "16k",
        },
        {
          value: "17000",
          label: "17k",
        },
        {
          value: "18000",
          label: "18k",
        },
        {
          value: "19000",
          label: "19k",
        },
        {
          value: "20000",
          label: "20k",
        },
        {
          value: "21000",
          label: "21k",
        },
        {
          value: "22000",
          label: "22k",
        },
        {
          value: "23000",
          label: "23k",
        },
        {
          value: "24000",
          label: "24k",
        },
        {
          value: "25000",
          label: "25k",
        },
        {
          value: "26000",
          label: "26k",
        },
        {
          value: "27000",
          label: "27k",
        },
        {
          value: "28000",
          label: "28k",
        },
        {
          value: "29000",
          label: "29k",
        },
        {
          value: "30000",
          label: "30k",
        },
        {
          value: "35000",
          label: "35k",
        },
        {
          value: "40000",
          label: "40k",
        },
        {
          value: "45000",
          label: "45k",
        },
        {
          value: "50000",
          label: "50k",
        },
        {
          value: "55000",
          label: "55k",
        },
        {
          value: "60000",
          label: "60k",
        },
      ],
      // 薪资月份列表
      salaryMonthsList: [
        {
          name: "1个月",
          value: "1",
        },
        {
          name: "2个月",
          value: "2",
        },
        {
          name: "3个月",
          value: "3",
        },
        {
          name: "4个月",
          value: "4",
        },
        {
          name: "5个月",
          value: "5",
        },
        {
          name: "6个月",
          value: "6",
        },
        {
          name: "7个月",
          value: "7",
        },
        {
          name: "8个月",
          value: "8",
        },
        {
          name: "9个月",
          value: "9",
        },
        {
          name: "10个月",
          value: "10",
        },
        {
          name: "11个月",
          value: "11",
        },
        {
          name: "12个月",
          value: "12",
        },
        {
          name: "13个月",
          value: "13",
        },
        {
          name: "14个月",
          value: "14",
        },
        {
          name: "15个月",
          value: "15",
        },
        {
          name: "16个月",
          value: "16",
        },
        {
          name: "17个月",
          value: "17",
        },
        {
          name: "18个月",
          value: "18",
        },
        {
          name: "19个月",
          value: "19",
        },
        {
          name: "20个月",
          value: "20",
        },
        {
          name: "21个月",
          value: "21",
        },
        {
          name: "22个月",
          value: "22",
        },
        {
          name: "23个月",
          value: "23",
        },
        {
          name: "24个月",
          value: "24",
        },
      ],
      // 公司地址
      companyAddressList: [],
      // 职业类别
      careerTypeList: [],
      props: {
        label: "label",
        value: "code",
      },
      // 自定义技能列表
      customizePositionSkillList: [],
      //  需要技能索引
      skillIndex: "",
      // 添加技能值
      addJnVal: "",
      // 添加技能框
      isShow: false,
      // 职业类别弹框
      PositionAndProfession: false,
      // 表单数据
      ruleForm: {
        // 职位类型
        jobType: 0,
        // 工作经验
        workExperience: "",
        // 学历要求
        education: -1,
        // 招聘职位
        positionName: "",
        // 职位描述
        positionDescribe: "",
        // 工作地点
        companyInfoAddressId: "",
        // 职业类别
        codeName: "",
        // 薪资范围
        salaryRange: "",
        // 最低薪资
        salaryMin: "",
        // 最高薪资
        salaryMax: "",
        // 薪资月数
        salaryMonths: "",
        // 回显编码
        dictCode: "",
        // 一类编码
        dictPositionCode1: "",
        // 二类编码
        dictPositionCode2: "",
        // 三类编码
        dictPositionCode: "",
        // 编码集合
        dictPositionList: [],
        // 需要技能
        skillIds: [],
      },
      // 校验规则
      rules: {
        jobType: [
          { required: true, message: "请选择招聘类型", trigger: "change" },
        ],
        positionName: [
          { required: true, message: "请输入职位名称", trigger: "blur" },
        ],
        positionDescribe: [
          { required: true, message: "请输入职位描述", trigger: "blur" },
          { min: 30, message: "职位描述至少输入30个字！", trigger: "blur" },
        ],
        dictPositionCode: [
          { required: true, message: "请选择职业类别", trigger: "change" },
        ],
        workExperience: [
          { required: true, message: "请选择工作经验", trigger: "change" },
        ],
        education: [
          { required: true, message: "请选择学历要求", trigger: "change" },
        ],
        salaryMonths: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 如果选择了面议，则不需要校验月份
              if (this.ruleForm.salaryMin === 0) {
                callback();
              } else {
                if (!value) {
                  callback(new Error('请选择薪资范围'));
                } else {
                  callback();
                }
              }
            },
            trigger: 'change'
          },
        ],
        companyInfoAddressId: [
          { required: true, message: "请选择工作地点", trigger: "change" },
        ],
        skillIds: [{ required: true, validator: skillIds, trigger: "blur" }],
      },
    };
  },
  created() {
    this.routeName = this.$route.name;
    this.getCompanyAddress();
    this.getCustomizePositionSkillList();
  },
  methods: {
    // 点击协议查看协议详情
    handelAgreement() {
      const route = this.$router.resolve({
        path: "/AboutUs/Express",
        query: { name: "招聘信息发布规范" },
      });
      window.open(route.href, '_blank');
    },
    // 获取企业职位详情
    getCompanyPositionDetail() {
      let data = {
        data: {
          positionId: this.$route.query.positionId,
        },
      };
      API.getCompanyPositionDetail(data).then((res) => {
        this.ruleForm = res.data;
        // 回显工作地点
        this.$set(this.ruleForm, "companyInfoAddressId", res.data.addressId);
        // 回显职业类别
        API.getPositionSelect({
          data: {},
        }).then((res2) => {
          this.ruleForm.dictPositionList = [
            res.data.dictPositionCode1,
            res.data.dictPositionCode2,
            res.data.dictPositionCode,
          ];
          // 确保回显时设置dictPositionCode2和dictPositionCode1
          this.$set(this.ruleForm, "dictPositionCode2", res.data.dictPositionCode2 || "");
          this.$set(this.ruleForm, "dictPositionCode1", res.data.dictPositionCode1 || "");
          for (var i in res2.data) {
            for (var k in res2.data[i].children) {
              for (var s in res2.data[i].children[k].children) {
                if (
                  res2.data[i].children[k].children[s].code ==
                  res.data.dictPositionCode
                ) {
                  // let name = res2.data[i].label + ' - ' + res2.data[i].children[k].label + ' - ' + res2.data[i].children[k].children[s].label
                  let name = res2.data[i].children[k].children[s].label;
                  this.$set(this.ruleForm, "codeName", name);
                }
              }
            }
          }
        });
        // 回显需要技能
        this.skillIds = res.data.positionSkills;
        this.customizePositionSkillList.forEach((item) => {
          res.data.positionSkills.forEach((items) => {
            if (items.companyUserSkillId == item.id) {
              item.checked = true;
            }
          });
        });
      });
    },
    // 关闭职位类别
    handleClose(num) {
      if (num == 0) {
        this.PositionAndProfession = !this.PositionAndProfession;
      }
    },
    // 确认职位类别
    handleUnderstand(num, code3, name3) {
      const level3Code = code3 != null ? String(code3) : "";
      const level3Name = name3 != null ? String(name3) : "";
      const path = this.findPositionPathByLevel3(level3Code);
      this.ruleForm.dictPositionCode = level3Code;
      this.ruleForm.dictPositionCode2 = path.code2 || "";
      this.ruleForm.dictPositionCode1 = path.code1 || "";
      this.ruleForm.dictCode =
        path.code1 && path.code2 && level3Code
          ? [path.code1, path.code2, level3Code]
          : "";
      this.ruleForm.codeName = level3Name;
      this.PositionAndProfession = !this.PositionAndProfession;
    },
    // 根据三级职位编码反查一级/二级编码，保证编辑页与发布页存储一致
    findPositionPathByLevel3(level3Code) {
      const code3 = level3Code != null ? String(level3Code) : "";
      const list =
        (this.$store && this.$store.getters && this.$store.getters.getPosition) ||
        [];
      for (const lv1 of list || []) {
        const children2 = (lv1 && lv1.children) || [];
        for (const lv2 of children2) {
          const children3 = (lv2 && lv2.children) || [];
          for (const lv3 of children3) {
            if (lv3 && String(lv3.code) === code3) {
              return {
                code1: lv1 && lv1.code ? String(lv1.code) : "",
                code2: lv2 && lv2.code ? String(lv2.code) : "",
              };
            }
          }
        }
      }
      return { code1: "", code2: "" };
    },
    // 获取自定义技能列表
    getCustomizePositionSkillList() {
      let data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
          userId: this.$store.getters.getUser.id,
        },
      };
      API.getCustomizePositionSkillList(data).then((res) => {
        this.customizePositionSkillList = res.data.map((item) => {
          let obj = {
            checked: false,
          };
          return { ...item, ...obj };
        });
        this.getCompanyPositionDetail();
      });
    },
    // 添加技能
    addJn() {
      const skillName = this.addJnVal ? this.addJnVal.trim() : "";
      if (!skillName) {
        this.$tool.PromptBox("error", "请输入技能名称！");
        return;
      }
      let data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
          userId: this.$store.getters.getUser.id,
          skillName,
        },
      };
      API.addCustomizePositionSkill(data).then((res) => {
        this.getCustomizePositionSkillList();
        this.addJnVal = "";
        this.$tool.PromptBox("success", "操作成功！");
        this.isShow = false;
      });
    },
    // 需要技能切换
    skillChange(item, index) {
      item.checked = !item.checked;
    },
    // 删除技能
    closeJn(item) {
      let that = this;
      this.$confirmWithScroll("是否删除该自定义技能？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((_) => {
          let data = {
            data: {
              companyId: that.$store.getters.getCompany.id,
              userId: that.$store.getters.getUser.id,
              skillName: item.skillName,
              id: item.id,
            },
          };
          API.delCustomizePositionSkill(data).then((res) => {
            that.getCustomizePositionSkillList();
            that.$tool.PromptBox("success", "操作成功！");
          });
        })
        .catch((_) => {});
    },

    // 获取公司地址
    getCompanyAddress() {
      let data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
        },
        pageNo: 1,
        pageSize: 1000,
      };
      API.getCompanyAddress(data).then((res) => {
        this.companyAddressList = res.data.list.map((item) => {
          // item.name = item.cityName + item.regionName + item.companyFullAddress
          item.name = item.companyFullAddress;
          return item;
        });
      });
    },

    // 薪资范围切换
    salaryMinChange(item) {
      const minValue = Number(item);
      if (minValue === 0) {
        this.ruleForm.salaryMax = 0;
        this.ruleForm.salaryMonths = ""; // 清除月份选择
        this.salaryList2 = [
          {
            label: "面议",
            value: 0,
          },
        ];
        // 清除校验错误
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate('salaryMonths');
        });
      } else {
        let index = this.salaryList.findIndex((items) => {
          return Number(items.value) === minValue;
        });
        this.salaryList2 = this.salaryList.slice(index + 1);
        if (
          this.ruleForm.salaryMax &&
          Number(this.ruleForm.salaryMax) <= minValue
        ) {
          this.ruleForm.salaryMax = "";
        }
      }
    },
    salaryMaxChange() {
      let that = this;

      if (!this.ruleForm.salaryMin) {
        that.$tool.PromptBox("error", "请先选择最低范围！");
        that.ruleForm.salaryMax = "";
      }
    },
    // 前往职位管理
    goZy() {
      this.$router.push({
        path: "/Firm/recruitPosition",
      });
    },
    // 表单确认
    submitForm(formName) {
      let that = this;
      this.ruleForm.skillIds = this.customizePositionSkillList
        .filter((items) => {
          return items.checked == true;
        })
        .map((items) => {
          return items.id;
        });
      console.log(this.ruleForm.skillIds);

      if (this.ruleForm.salaryMin == this.ruleForm.salaryMax) {
        this.ruleForm.salaryRange = "面议";
      } else {
        this.ruleForm.salaryRange =
          this.ruleForm.salaryMin / 1000 +
          "k" +
          "-" +
          this.ruleForm.salaryMax / 1000 +
          "k";
      }
      let data = {
        data: {
          ...this.ruleForm,
          ...{
            companyId: this.$store.getters.getCompany.id,
            publishUserId: this.$store.getters.getUser.id,
            id: this.$route.query.positionId
              ? this.$route.query.positionId
              : "",
          },
        },
      };
      console.log(data);

      this.$refs[formName].validate((valid) => {
        if (valid) {
          API.publishPosition(data).then((res) => {
            if (res.code == 0) {
              that.$tool.PromptBox("success", "操作成功！");
              this.$refs[formName].resetFields();
              this.goZy();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 清除表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-textarea .el-input__count {
  color: #909399;
  background: transparent !important;
  position: absolute;
  font-size: 12px;
  bottom: -10px !important;
}

/* 验证失败红色边框（与发布页一致） */
/deep/ .el-form-item.is-error .el-input__inner {
  border-color: #fe574a !important;
}
/deep/ .el-form-item.is-error textarea {
  border-color: #fe574a !important;
}

.Back-btn {
  width: 110px;
  height: 30px;
  background: rgba(97, 144, 232, 0.3);
  border-radius: 5px;
  display: flex;
  cursor: pointer;
  margin-left: 30px;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 99;
  .Back-style {
    width: 50px;
    height: 17px;
    line-height: 17px;
    margin: auto;
    display: flex;
    div {
      width: 14px;
      height: 17px;
      background-image: url("../../../../assets/imgs/back-da@3x.svg");
      background-size: 100% 100%;
    }
    p {
      font-size: 14px;
      color: #409eff ;
      margin-left: 5px;
      cursor: pointer;
    }
  }
}

.firm-body {
  .box {
    width: 100%;
    min-height: 750px;
    box-sizing: border-box;
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
    border-radius: 20px;
    padding: 10px 30px;
    overflow-y: auto;
    position: relative;

    .demo-ruleForm {
      .box-title {
        width: 80px;
        height: 60px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 10px;

        span {
          font-size: 20px;
          font-weight: 400;
        }

        img {
          position: absolute;
          bottom: 10px;
          left: 0px;
        }
      }
    }

    .type-box {
      width: 90px;
      height: 35px;
      line-height: 35px;
      background: #ffffff;
      border: 1px solid #409eff ;
      border-radius: 5px;
      text-align: center;
      color: #409eff ;
      margin: 0px 10px 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;
      box-sizing: border-box;
      font-size: 12px;
    }

    .type-box:hover .guanbi {
      display: block;
    }

    .type-box-active {
      background: #d4e1f9;
      color: #409eff ;
    }

    .guanbi {
      position: absolute;
      right: -10px;
      top: -10px;
      z-index: 99;
      display: none;
    }

    /* 需要技能：添加技能弹层不撑高整体高度（与发布页一致） */
    .skill-wrapper {
      position: relative;
      min-height: 40px;
    }
    .skill-add-pop {
      position: absolute;
      left: 0;
      top: 48px;
      background: #ffffff;
      padding: 10px 12px;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      z-index: 10;
    }
  }
}
</style>
